import AbstractController from "../../../vendors/services/abstractController";
import { useState } from "react";
import ContribuicaoService from "../../services/contribuicao.service";
import ToastService from "../../../vendors/services/toastService";
import { Mensagem } from "../../shared/mensagem/Mensagem";
import FilaContribuicaoUtil from "../../shared/utils/FilaContribuicaoUtil";

interface FinalizarNextOptions {
  skipBlockUI?: boolean;
  skipToast?: boolean;
  skipNavegacao?: boolean;
}

export default class EventoFinalizarController extends AbstractController {
  public showContribuirComo: any;
  public setshowContribuirComo: any;
  public showCiencia: any;
  public setShowCiencia: any;
  public showSatisfacao: any;
  public setShowSatisfacao: any;
  public eventoFinalizar: any;
  public setEventoFinalizar: any;
  public contribuicaoService: any;
  public noUsuarioCadastro: any;
  public setNoUsuarioCadastro: any;
  public empresaList: any;
  public setEmpresaList: any;
  public cpf: any;
  public setCpf: any;
  public isPrimeiraContrib: any;
  public setIsPrimeiraContrib: any;
  public satisfacaoResposta: any;
  public setSatisfacaoResposta: any;

  constructor() {
    super();
    [this.showCiencia, this.setShowCiencia] = useState(false);
    [this.showSatisfacao, this.setShowSatisfacao] = useState(false);
    [this.showContribuirComo, this.setshowContribuirComo] = useState(false);
    [this.eventoFinalizar, this.setEventoFinalizar] = useState({});
    [this.noUsuarioCadastro, this.setNoUsuarioCadastro] = useState("");
    [this.empresaList, this.setEmpresaList] = useState([]);
    [this.cpf, this.setCpf] = useState("");
    [this.isPrimeiraContrib, this.setIsPrimeiraContrib] = useState(false);
    [this.satisfacaoResposta, this.setSatisfacaoResposta] = useState(null);
    this.contribuicaoService = new ContribuicaoService();
  }

  init() {
    const dados = this.getUser();
    if (dados !== undefined) {
      this.setEmpresaList(dados.dadosLoginUnico.empresaList);
      this.setCpf(dados.cpf);
      this.setNoUsuarioCadastro(dados.cpf);
    }
  }

  private getMembro() {
    return JSON.parse(sessionStorage.getItem("membro") || "{}");
  }

  onShowFinalizar() {
    this.setshowContribuirComo(true);
  }

  showFinalizar(_evento: any, controller: any) {
    this.start();
    const membro = this.getMembro();
    this.contribuicaoService
      .isPrimeiraContribuicao(
        membro.codContribuinte
          ? membro.codContribuinte
          : this.getCodContribuinte(),
        _evento.codAudienciaPublica
      )
      .then((res: any) => {
        if (!res.data) {
          if (controller == null) {
            this.finalizar(null, _evento);
          } else {
            this.finalizarNext(null, _evento, controller);
          }
        } else {
          this.stop();
          this.setShowCiencia(true);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.stop();
      });
  }

  onHideCiencia() {
    this.setShowCiencia(false);
  }

  onHideSatisfacao() {
    this.setShowSatisfacao(false);
  }

  onHideContribuirComo() {
    this.setshowContribuirComo(false);
  }

  finalizarCiencia(e: any) {
    const membro = this.getMembro();
    this.setShowCiencia(false);
    this.setEventoFinalizar({
      ...this.eventoFinalizar,
      CienciaEventoOutros: e.CienciaEventoOutros,
      cdCienciaEvento: e.cdCienciaEvento,
      stReceberNotificacao: e.stReceberNotificacao,
      noUsuarioCadastro: membro.cpf ? membro.cpf : this.noUsuarioCadastro,
    });
    const that = this;
    this.start();
    setTimeout(() => {
      that.setShowSatisfacao(true);
      that.stop();
    }, 500);
  }

  finalizar(resposta: any, _evento: any) {
    const membro = this.getMembro();

    const _eventoFinalizar = {
      ...this.eventoFinalizar,
      codContribuinte: membro.codContribuinte
        ? membro.codContribuinte
        : this.getCodContribuinte(),
      cdAudienciaPublica: _evento.codAudienciaPublica,
    };
    _eventoFinalizar.resposta = resposta;
    _eventoFinalizar.noUsuarioCadastro = membro.cpf
      ? membro.cpf
      : this.noUsuarioCadastro;
    this.start();
    this.contribuicaoService
      .finalizar(_eventoFinalizar)
      .then((res: any) => {
        ToastService.showSuccess(Mensagem.SUCESSO);
        this.stop();
        this.history.push("/home");
      })
      .catch((err: any) => {
        this.stop();
      });
  }

  finalizarNext(
    resposta: any,
    _evento: any,
    controller: any,
    options: FinalizarNextOptions = {}
  ): Promise<void> {
    const {
      skipBlockUI = false,
      skipToast = false,
      skipNavegacao = false,
    } = options;
    const membro = this.getMembro();
    const temAnexo = controller?.arquivoList?.length > 0;
    const _eventoFinalizar = {
      ...this.eventoFinalizar,
      codContribuinte: membro.codContribuinte
        ? membro.codContribuinte
        : this.getCodContribuinte(),
      cdAudienciaPublica: _evento.codAudienciaPublica,
    };
    _eventoFinalizar.resposta = resposta;
    _eventoFinalizar.noUsuarioCadastro = membro.cpf
      ? membro.cpf
      : this.noUsuarioCadastro;
    if (temAnexo) {
      _eventoFinalizar.inativo = true;
    }

    if (!skipBlockUI) {
      this.start();
    }

    return this.contribuicaoService
      .finalizar(_eventoFinalizar)
      .then(async () => {
        if (temAnexo) {
          await this.contribuicaoService.ativar({
            codAudienciaPublica: _evento.codAudienciaPublica,
            codContribuinte: _eventoFinalizar.codContribuinte,
          });
        }
        if (!skipToast) {
          ToastService.showSuccess(Mensagem.SUCESSO);
        }
        if (!skipNavegacao && controller != null) {
          controller.proximaContribuicao();
        }
      })
      .catch((err: any) => {
        if (!skipToast) {
          ToastService.showError(Mensagem.ERRO);
        }
        console.log(err);
        throw err;
      })
      .finally(() => {
        if (!skipBlockUI) {
          this.stop();
        }
      });
  }

  async checkInitialModals(currentId: number, codAudienciaPublica: any) {
    const fila = FilaContribuicaoUtil.getFila();
    const isFirstInQueue = !fila || fila.length === 0 || fila[0] === currentId;

    if (!isFirstInQueue) return;

    const membro = this.getMembro();
    const codContribuinte = membro.codContribuinte
      ? membro.codContribuinte
      : this.getCodContribuinte();

    this.start();
    try {
      const res: any = await this.contribuicaoService.isPrimeiraContribuicao(
        codContribuinte,
        codAudienciaPublica
      );

      if (res.data) {
        this.setIsPrimeiraContrib(true);
        this.setShowCiencia(true);
      } else {
        this.setIsPrimeiraContrib(false);
        this.setshowContribuirComo(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      this.stop();
    }
  }

  finalizarSatisfacao(e: any) {
    this.setSatisfacaoResposta(e);
    this.setShowSatisfacao(false);
    const that = this;
    setTimeout(() => {
      that.setshowContribuirComo(true);
    }, 300);
  }

  confirmarContribuirComo() {
    this.setshowContribuirComo(false);
  }
}
